














































import { Component, Vue } from 'vue-property-decorator';
@Component({})
  export default class FrameA extends Vue {
    /* TODO: Move data to service & use correct images */
    private data() {
      return {
        items: [
          {
            src: 'https://firebasestorage.googleapis.com/v0/b/danko-v1.appspot.com/o/carousel%2Fgood-vibes_308x350.jpg?alt=media&token=20e03b45-292a-43ae-b87b-6f403c00176e',
            height: '350px',
            top: '0',
            background: '#331f19',
            text: 'Manufactured using only the finest California Primo produced by the best growers in the world.',
            link: '/our-products',
            buttonText: 'Learn more...',
            knockout: true,
            serif: true
          },
          {
            src: 'https://firebasestorage.googleapis.com/v0/b/danko-v1.appspot.com/o/carousel%2Fwish-you-were-here_350.jpg?alt=media&token=feec4e4c-de2a-4d5d-84b1-e494641beb0d',
            height: '500px',
          },
          {
            src: 'https://firebasestorage.googleapis.com/v0/b/danko-v1.appspot.com/o/carousel%2Fsweet-jane_350.jpg?alt=media&token=72a83ea8-d81d-4ab2-b5a6-0251a3bb3400',
            height: '500px',
            text: 'Introducing Sweet Jane®  by Doc Danko. A cannabis sativa elixer formulated from only the finest California Primo.',
            link: '/our-products',
            buttonText: 'Learn more...',
            knockout: true,
            serif: true,
            textTop: '340px',
          },
          {
            src: 'https://firebasestorage.googleapis.com/v0/b/danko-v1.appspot.com/o/carousel%2Fprimo-fruits_350.jpg?alt=media&token=a04cb938-d66d-4a58-b38c-3c202504c139',
            height: '500px',
          },
          {
            src: 'https://firebasestorage.googleapis.com/v0/b/danko-v1.appspot.com/o/carousel%2Fblack-betty_350.jpg?alt=media&token=cffb0c1d-1702-4bec-bd8f-cec1b357b348',
            height: '500px',
            text: 'Introducing Black Betty® by Doc Danko. From the dankest indica, an elixer that redefines chill.',
            link: '/our-products',
            buttonText: 'Learn more...',
            knockout: true,
            serif: false,
            textTop: '370px',
          },
          {
            src: 'https://firebasestorage.googleapis.com/v0/b/danko-v1.appspot.com/o/carousel%2Fto-your-head_350.jpg?alt=media&token=6be45878-e7c8-4b3e-8218-4fa7e234b6bc',
            height: '500px',
          },
        ],
        frameOne: {
          topFuse: {
            baseImage: {
              url: require('../../assets/home-mech/frame-A/fuse-top_256x180.png'),
              alt: 'frame one fuse top base image',
            },
            sparkA: {
              url: require('../../assets/home-mech/frame-A/fuse-top-spark-1_256x180.png'),
              alt: 'frame one fuse top spark A',
            },
            sparkB: {
              url: require('../../assets/home-mech/frame-A/fuse-top-spark-2_256x180.png'),
              alt: 'frame one fuse top spark B',
            },
            glow: {
              url: require('../../assets/home-mech/frame-A/fuse-top-gauge-glow_18x18.png'),
              alt: 'frame one fuse top gauge glow',
            },
          },
          bottomBlock: {
            baseImage: {
              url: require('../../assets/home-mech/frame-A/fan-block-bottom_104x100.png'),
              alt: 'frame one fan block base',
            },
            fanBlades: {
              url: require('../../assets/home-mech/frame-A/fan-block-bottom-blades_36x38.png'),
              alt: 'frame one fan block blades',
            },
          },
        },
      };
    }
  }
